import React from 'react'
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton
} from 'react-share'

import GoogleContacts from 'react-google-contacts';
import { navigate } from 'gatsby';

const SocialMediaBtns = (props) => {

  const responseCallback = (response) => {
    // console.log(response)
    navigate(
      '/invite/',
      {
        state : {response},
      }
    )
  }

  return <div className="share">
    <LinkedinShareButton
      url={props.url}
      title={props.text}>
      <div className='btn _in'>
        <i className="mdi mdi-linkedin" />
      </div>
    </LinkedinShareButton>

    <TwitterShareButton
      url={props.url}
      title={props.text}>
      <div className='btn _tw'>
        <i className="mdi mdi-twitter" />
      </div>
    </TwitterShareButton>

    <FacebookShareButton
      url={props.url}
      quote={props.text}>
      <div className="btn _fb">
        <i className="mdi mdi-facebook" />
      </div>
    </FacebookShareButton>


    <GoogleContacts
      clientId="243240627055-e70m65os9t7de3t0t2fdq564so5o15cu.apps.googleusercontent.com"
      render={renderProps => (
        <button
          className='help sm'
          onClick={renderProps.onClick}>
          Help friends build with F22
        </button>
      )}
      buttonText="Import"
      onSuccess={responseCallback}
      onFailure={responseCallback}
      redirectUri='https://dazzling-mirzakhani-8704fb.netlify.app/invite/'
    />

  </div>
}

export default SocialMediaBtns